import { supabase } from "../supabase/SupabaseClient";

/* Novedades del personal del puerto (P-181, Natalia).
 *
 * ── ES UNA PANTALLA DE MIRAR ───────────────────────────────────────────────
 *
 * Las novedades entran por WhatsApp (`novedad no tenemos la llave de 32`): la
 * gente del puerto avisa con las manos sucias, sin usuario ni clave. Duplicar
 * la carga acá obligaría a adivinar en cuál de los dos lados se anota — la
 * lección de los dos talleres. Lo único que se escribe desde el hub es
 * **anular** una novedad mal cargada, y anular no es borrar.
 *
 * ── LO QUE DE VERDAD RESTRINGE ES LA RLS ──────────────────────────────────
 *
 * La tabla pide `ver.puerto` para leer y `cargar.puerto` para anular, del lado
 * de la BASE. Sin el permiso estas consultas vuelven vacías aunque se las llame
 * desde la consola del navegador — el menú sólo decide qué baldosa se dibuja.
 */

/* Las novedades vigentes, de la más nueva a la más vieja. Las anuladas NO se
 * piden: la fila queda en la base y la pantalla de todos los días muestra lo
 * que vale. */
export async function novedades(limite = 200) {
  const { data, error } = await supabase
    .from("puerto_novedades")
    .select("id, numero, persona, rol, detalle, tipo, creado_en")
    .is("anulado_en", null)
    .order("creado_en", { ascending: false })
    .limit(limite);
  if (error) throw error;
  return data || [];
}

/* Anular una novedad mal cargada. NO BORRA —mismo criterio que un trabajo
 * anulado—: queda con quién la anuló, que es la pregunta del día que alguien
 * busca la novedad que cargó y no la encuentra. */
export async function anularNovedad(id, mail) {
  const { error } = await supabase
    .from("puerto_novedades")
    .update({ anulado_en: new Date().toISOString(), anulado_por: mail || null })
    .eq("id", id);
  if (error) throw error;
}
